import {FDA_R3_REPORT_TYPE_CODE, MFDS_REPORT_TYPE_CODE} from '@/utils/Constants';

export default class DataUtils {

    public static isXMLReportType(reportType: string): boolean {
        return reportType.indexOf('XML') >= 0;
    }

    public static isExcelReportType(reportType: string): boolean {
        return reportType.indexOf('EXCEL') >= 0;
    }

    public static getFdaR3ReportTypeValue(reportTypeInReceiverName: string): string {
        return FDA_R3_REPORT_TYPE_CODE[reportTypeInReceiverName] ?? '';
    }

    public static getMFDSReportTypeValue(reportTypeInReceiverName: string): string {
        return MFDS_REPORT_TYPE_CODE[reportTypeInReceiverName] ?? '';
    }

    public static getSelectLibrariesColumns(libraryName: string, description: string) {
        return [
            {columnId: 'SCH_NAME', columnLabel: libraryName, visible: 'Y'},
            {columnId: 'DESCRIPTION', columnLabel: description, visible: 'Y'}
        ];
    }
}

